import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function eircodeValidator(): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const { value } = control;

    if (!value) return null;

    const eircodeRegex =
      /^[ACDEFHJKNPRTUVWXYacdefhjknprtuvwxy]{1}[0-9BILOSZbilosz]{1}[0-9WBILOSZwbilosz]{1}[ ]{0,1}[0-9ACDEFHJKNPRTUVWXYacdefhjknprtuvwxyBILOSZbilosz]{4}$/g;

    if (eircodeRegex.test(value)) return null;

    return {
      eircode: true,
    };
  };
}
